import { KsService, useApiClient } from '@siclop/kstone-vue'
import type { ProjectFullDataDTO } from '../models/ProjectFullDataDTO'

export class ProjectService extends KsService {
  protected static mainUrl = '/projects'

  /**
   * Get all project data in a single request (eliminates N+1 queries)
   */
  static async getFullData(projectId: number): Promise<ProjectFullDataDTO> {
    const client = useApiClient()
    return client.get<ProjectFullDataDTO>(`${this.mainUrl}/${projectId}/full-data`)
  }

  /**
   * Get time analysis for a project grouped by activity type
   */
  static async getTimeAnalysis(projectId: number): Promise<TimeAnalysisDTO> {
    const client = useApiClient()
    return client.get<TimeAnalysisDTO>(`${this.mainUrl}/${projectId}/time-analysis`)
  }

  /**
   * Update project status
   */
  static async updateStatus(id: number, status: number) {
    const client = useApiClient()
    return client.post(`${this.mainUrl}/${id}/status`, { status } as any)
  }
}

export interface TimeAnalysisRow {
  activityTypeId: number
  label: string
  theoreticalHours: number
  actualHours: number
  invoicedHours: number
  difference: number
  differencePercent: number
}

export interface TimeAnalysisTotals {
  theoreticalHours: number
  actualHours: number
  invoicedHours: number
  difference: number
  differencePercent: number
}

export interface TimeAnalysisDTO {
  rows: TimeAnalysisRow[]
  totals: TimeAnalysisTotals
}
